import React from 'react';

const Unauthorized = () => {
    return <span>You currently do not have access to Media Flow Admin.</span>
}

export default Unauthorized;